import {call, put} from 'redux-saga/effects';
import {createArtworkOfSnapshot, CreationArtworkBody} from '@pluto/rest';

interface Props {
    type: string;
    payload: {
        id: number;
        params: CreationArtworkBody;
    };
}

export function* createArtworkRest(action: Props) {
    const {id, params} = action.payload;
    try {
        yield call(createArtworkOfSnapshot, id, params);
        yield put({
            type: 'NOTIFICATION_SET',
            payload: {
                type: 'success',
                text: 'Artwork has been created',
            },
        });
    } catch {
        yield put({
            type: 'NOTIFICATION_SET',
            payload: {
                type: 'error',
                text: 'Failed to create artwork',
            },
        });
    }
}
